export default __webpack_public_path__ + "static/media/efix_51_129.128d7571.png";